import { apiPrefix } from "./common";

import axios from "axios";

export default {
  getMyInfo() {
    let res = axios.get(apiPrefix("/user"));
    return res;
  },

  postMyInfo(form) {
    let res = axios.post(apiPrefix("/user"), form);
    return res;
  },
};
